import React, { useState } from "react";
import PhotoModal from "../../calendar/progress-photos/PhotoModal";
import {
  findFrontLeftBack,
  mapPhotos,
} from "../../calendar/body-composition/body-composition.helper";
import SvgIcon from "../../../../parts/SvgIcon";

const QuestionProgressPictures = () => {
  return (
    <div className="question-progress-pictures">
      <div className="progress-picture">
        <SvgIcon src={"/img/new-icons/add.svg"} />
        <span>Front</span>
      </div>
      <div className="progress-picture">
        <SvgIcon src={"/img/new-icons/add.svg"} />
        <span>Back</span>
      </div>
      <div className="progress-picture">
        <SvgIcon src={"/img/new-icons/add.svg"} />
        <span>Side</span>
      </div>
    </div>
  );
};

export const CreateQuestionProgressPictureBody = () => {
  return (
    <div className="answer-scale-body">
      <QuestionProgressPictures />
      <div className="no-buttons"></div>
    </div>
  );
};

export const ProgressPictureAnswer = ({ dailyStats }) => {
  const progressPhotos = getProgressPhotos(dailyStats);

  if (!progressPhotos) {
    return <span className="question-description-short">No data to show</span>;
  }

  const [modal, setModal] = useState({
    open: false,
    type: "",
    pictureImg: "",
  });

  const toggleModal = (pictureImg = "", type = "") => {
    setModal({
      open: modal.open ? false : true,
      type,
      pictureImg,
    });
  };

  return (
    <section role="progress-photos-wrapper">
      <div>
        {Object.keys(progressPhotos).map((key) =>
          progressPhotos[key] ? (
            <img
              key={`${key}-photo`}
              src={progressPhotos[key]}
              className="question-photo"
              onClick={() => {
                progressPhotos[key]
                  ? toggleModal(progressPhotos[key], key)
                  : null;
              }}
            />
          ) : (
            <div className="photo-empty"></div>
          )
        )}
      </div>
      {modal.open ? (
        <PhotoModal photo={modal} toggleModal={toggleModal} />
      ) : null}
    </section>
  );
};

const getProgressPhotos = (dailyStats) => {
  const filteredPhotos = dailyStats
    .slice()
    .filter((stat) => stat.bodyPhotos)
    .sort((a, b) => a.utcDate - b.utcDate)
    .map(mapPhotos);

  const result = findFrontLeftBack(filteredPhotos);

  const quantityOfPhotos = Object.keys(result).length;

  return quantityOfPhotos > 0 ? result : null;
};

export default QuestionProgressPictures;
